import { toast } from '@pella/sash-framework';

export const sweetLoader =
  '<div class="sweet_loader"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div>';

/**
 * Shows a deprecation warning for the loader function
 */
export const showLoader = () => {
  // Note: showLoading is not available in toast. Consider using a loading component instead.
  // eslint-disable-next-line no-console
  console.warn('showLoader is deprecated. Please use a loading component instead.');
};
/**
 * Show alert using toast
 * @param {object} param0
 * @param {string} param0.title - The title/message to display
 * @param {string} param0.text - Additional text (will be appended to title)
 * @param {string} param0.type - The type of alert (success, error, warning, info)
 * @param {string} [param0._button] - Optional button text (ignored)
 */
export const showAlert = ({ title, text, type, _button }) => {
  const message = text ? `${title}: ${text}` : title;
  const toastType = type || 'success';

  // Call the appropriate toast method based on type
  switch (toastType) {
    case 'error':
      toast.error(message || '');
      break;
    case 'warning':
      toast.warning(message || '');
      break;
    case 'info':
      toast.info(message || '');
      break;
    case 'success':
    default:
      toast.success(message || '');
      break;
  }
};
